module.exports = __webpack_public_path__ + "static/media/finidcard.098f66a4.png";